import audio1 from 'assets/sounds/nn/diktat/18.mp3'; //1
import audio2 from 'assets/sounds/nn/diktat/30.mp3'; //2
import audio3 from 'assets/sounds/nn/diktat/19.mp3'; //3
import audio4 from 'assets/sounds/nn/diktat/23.mp3'; //4
import audio5 from 'assets/sounds/nn/diktat/26.mp3'; //5
import audio6 from 'assets/sounds/nn/diktat/27.mp3'; //6
import audio7 from 'assets/sounds/nn/diktat/28.mp3'; //7
import audio8 from 'assets/sounds/nn/diktat/25.mp3'; //8
import audio10 from 'assets/sounds/nn/diktat/02.mp3'; //10
import audio11 from 'assets/sounds/nn/diktat/06.mp3'; //11
import audio12 from 'assets/sounds/nn/diktat/03.mp3'; //12
import audio13 from 'assets/sounds/nn/diktat/04.mp3'; //13
import audio14 from 'assets/sounds/nn/diktat/05.mp3'; //14
import audio15 from 'assets/sounds/nn/diktat/norming/15.mp3'; //15
import audio16 from 'assets/sounds/nn/diktat/08.mp3'; //16
import audio17 from 'assets/sounds/nn/diktat/24.mp3'; //17
import audio18 from 'assets/sounds/nn/diktat/09.mp3'; //18
import audio19 from 'assets/sounds/nn/diktat/10.mp3'; //19
import audio20 from 'assets/sounds/nn/diktat/11.mp3'; //20
import audio21 from 'assets/sounds/nn/diktat/12.mp3'; //21
import audio22 from 'assets/sounds/nn/diktat/norming/22.mp3'; //22
import audio23 from 'assets/sounds/nn/diktat/norming/23.mp3'; //23
import audio24 from 'assets/sounds/nn/diktat/15.mp3'; //24
import audio25 from 'assets/sounds/nn/diktat/16.mp3'; //25
import audio26 from 'assets/sounds/nn/diktat/17.mp3'; //26
import audio27 from 'assets/sounds/nn/diktat/norming/27.mp3'; //27
import audio28 from 'assets/sounds/nn/diktat/22.mp3'; //28
import audio29 from 'assets/sounds/nn/diktat/norming/29.mp3'; //27
import audio30 from 'assets/sounds/nn/diktat/norming/30.mp3'; //27

const audioFiles = {
	1: audio1,
	2: audio2,
	3: audio3,
	4: audio4,
	5: audio5,
	6: audio6,
	7: audio7,
	8: audio8,
	9: audio10,
	10: audio11,
	11: audio12,
	12: audio13,
	13: audio14,
	14: audio15,
	15: audio16,
	16: audio17,
	17: audio18,
	18: audio19,
	19: audio20,
	20: audio21,
	21: audio22,
	22: audio23,
	23: audio24,
	24: audio25,
	25: audio26,
	26: audio27,
	27: audio28,
	28: audio29,
	29: audio30,
};

export default audioFiles;
